import {environmentBounds} from './mapEnvironmentGeometry.js';

export const MAP_PACKAGE_LIMIT=256*1024*1024;
export const MAP_PACKAGE_TILE_LIMIT=12000;
export const MAP_PACKAGE_LAYERS=['relief','contours','color'];
export const mapAssetUrl=hash=>'/api/prepared-map/tiles/'+hash+'.png';
export const mapTileKey=tile=>`${tile.layer}/${tile.z}/${tile.x}/${tile.y}`;
export const mapPackageCache='sonata-prepared-map-tiles-v1';

/** Whole-property envelope plus 250 m. Fixed native zooms, never predictive. */
export function mapPackagePlan(boundary,layers=MAP_PACKAGE_LAYERS){
 const area=environmentBounds(boundary);if(!area)throw Error('A valid local property boundary is required.');
 if(!Array.isArray(layers)||!layers.length||new Set(layers).size!==layers.length||layers.some(layer=>!MAP_PACKAGE_LAYERS.includes(layer)))throw Error('Unsupported map package layers.');
 const [[south,west],[north,east]]=area.propertyBounds;
 const lonMeters=111195*Math.cos(area.center[0]*Math.PI/180);
 const bounds=[[south-250/111195,west-250/lonMeters],[north+250/111195,east+250/lonMeters]];
 const x=(lon,z)=>Math.floor((lon+180)/360*2**z),y=(lat,z)=>Math.floor((1-Math.asinh(Math.tan(lat*Math.PI/180))/Math.PI)/2*2**z);
 const tiles=[];
 for(const layer of layers)for(let z=12;z<=18;z++){
  for(let yy=y(bounds[1][0],z);yy<=y(bounds[0][0],z);yy++)for(let xx=x(bounds[0][1],z);xx<=x(bounds[1][1],z);xx++){
   if(xx<0||yy<0||xx>=2**z||yy>=2**z)throw Error('Map coverage crosses an unsupported edge.');
   tiles.push({layer,z,x:xx,y:yy});if(tiles.length>MAP_PACKAGE_TILE_LIMIT)throw Error('This property exceeds the complete map package limit.');
  }
 }
 return {propertyBounds:area.propertyBounds,bounds,layers:[...layers],minZoom:12,maxZoom:18,tiles};
}

/** Recompute coverage, not merely a claimed count. Reject duplicates and holes. */
export function validateMapPackage(value,boundary){
 if(!value||value.schema!==1||!/^[-a-zA-Z0-9_]{1,100}$/.test(value.farmId)||!Number.isFinite(Date.parse(value.builtAt)))throw Error('Invalid prepared map.');
 const plan=mapPackagePlan(boundary,value.layers);
 if(JSON.stringify(plan.propertyBounds)!==JSON.stringify(value.propertyBounds)||JSON.stringify(plan.bounds)!==JSON.stringify(value.bounds)||value.minZoom!==plan.minZoom||value.maxZoom!==plan.maxZoom)throw Error('Prepared map does not match this property.');
 if(!value.range||!Number.isFinite(value.range.minMeters)||!Number.isFinite(value.range.maxMeters)||value.range.minMeters < -500||value.range.maxMeters>9000||value.range.maxMeters<=value.range.minMeters)throw Error('Invalid prepared elevation range.');
 if(!Array.isArray(value.tiles)||value.tiles.length!==plan.tiles.length)throw Error('Prepared map coverage is incomplete.');
 const expected=new Set(plan.tiles.map(mapTileKey)),files=new Map();let bytes=0;
 for(const tile of value.tiles){
  if(![tile.z,tile.x,tile.y].every(Number.isInteger)||!expected.delete(mapTileKey(tile))||!/^[a-f0-9]{64}$/.test(tile.hash)||!Number.isInteger(tile.bytes)||tile.bytes<1||tile.bytes>2*1024*1024)throw Error('Invalid prepared map tile.');
  if(files.has(tile.hash)&&files.get(tile.hash)!==tile.bytes)throw Error('Conflicting file sizes.');
  if(!files.has(tile.hash)){files.set(tile.hash,tile.bytes);bytes+=tile.bytes;}
 }
 if(expected.size||bytes!==value.bytes||bytes>MAP_PACKAGE_LIMIT)throw Error('Prepared map is incomplete or too large.');
 return value;
}
